export const requestedDateInfo = () => {
  return (
    <>
      <div className="info-title">Request date</div>
      <div className="info-content">
        The date the return was requested.
      </div>
    </>
  );
};

export const rejectionDateInfo = () => {
  return (
    <>
      <div className="info-title">Rejection date</div>
      <div className="info-content">
        The date the return was rejected.
      </div>
    </>
  );
};

export const approvalDateInfo = () => {
  return (
    <>
      <div className="info-title">Approval date</div>
      <div className="info-content">
        The date the return was approved.
      </div>
    </>
  );
};

export const returnIdInfo = () => {
  return (
    <>
      <div className="info-title">Return ID</div>
      <div className="info-content">
        <div>
          The unique number that identifies the return request.
        </div>
      </div>
    </>
  );
};

export const OrderNameInfo = () => {
  return (
    <>
      <div className="info-title">Order</div>
      <div className="info-content">
        <div>
          An order is a confirmed request to utilize one or more product SKUs.
        </div>
      </div>
    </>
  );
};

export const unitUsedInfo = () => {
  return (
    <>
      <div className="info-title">Units used</div>
      <div className="info-content">
        <div>
          The number of units and cost consumed during the usage period. For variable SKUs, the ordered units may differ from the consumed units.
        </div>
      </div>
    </>
  );
};

export const returnUnitUsedInfo = () => {
  return (
    <>
      <div className="info-title">Return Units</div>
      <div className="info-content">
        <div>
          The number of units and cost requested in the return.
        </div>
      </div>
    </>
  );
};

export const approvedUnitUsedInfo = () => {
  return (
    <>
      <div className="info-title">Approved Units</div>
      <div className="info-content">
        <div>
          The number of units and cost that were accepted based on the requested return.
        </div>
      </div>
    </>
  );
};

export const returnStatusInfo = () => {
  return (
    <>
      <div className="info-title">Status</div>
      <div className="info-content">
        <div>
          Indicates the current state of the return request. Possible statuses are:
          <ul>
            <li>In approval – The return request is still under review.</li>
            <li>Approved – The return request has been accepted.</li>
            <li>Rejected – The return request was not accepted and can be submitted again.</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export const usagesPeriodInfo = () => {
  return (
    <>
      <div className="info-title">Usage period</div>
      <div className="info-content">
        The start and end dates during which the SKU is used.
      </div>
    </>
  );
};
export const usagesIntervalInfo = () => {
  return (
    <>
      <div className="info-title">Usage interval</div>
      <div className="info-content">
        Shows two values: the number of consecutive transactions and the total number of requested periods.
      </div>
    </>
  );
};

export const returnReasonInfo = () => {
  return (
    <>
      <div className="info-title">Return reason</div>
      <div className="info-content">
        The reason the return was requested.
      </div>
    </>
  );
};

export const rejectionReasonInfo = () => {
  return (
    <>
      <div className="info-title">Rejection reason</div>
      <div className="info-content">
        The reason the return request was rejected.
      </div>
    </>
  );
};

export const transactionDateInfo = () => {
  return (
    <>
      <div className="info-title">Transaction date</div>
      <div className="info-content">
        The date the transaction was sent to the financial system and charged to the engagement code.
      </div>
    </>
  );
};